<template lang="pug">
nav.language-switcher(:aria-label='label')
  v-menu(location='bottom end', offset='8')
    template(#activator='{ props: menuProps }')
      v-btn.language-switcher-button(
        v-bind='menuProps'
        variant='outlined'
        density='comfortable'
        :aria-label='label'
      )
        span.language-switcher-flag(aria-hidden='true') {{ current.flag }}
        span.language-switcher-code {{ current.code.toUpperCase() }}
        v-icon(size='18', aria-hidden='true') mdi-chevron-down
    v-list.language-switcher-menu(density='compact')
      v-list-item(
        v-for='item in items'
        :key='item.code'
        :to='item.path'
        :active='item.code === activeCode'
        :aria-label='t("language.switchTo", { language: item.name })'
      )
        template(#prepend)
          span.language-switcher-flag(aria-hidden='true') {{ item.flag }}
        v-list-item-title {{ item.name }}
</template>

<script setup lang="ts">
export type LanguageSwitcherItem = {
  code: string
  name: string
  flag: string
  path: string
}

defineProps<{
  items: LanguageSwitcherItem[]
  current: LanguageSwitcherItem
  activeCode: string
  label: string
}>()

const { t } = useI18n()
</script>

<style scoped>
.language-switcher {
  display: inline-flex;
  align-items: center;
}

.language-switcher-button {
  min-width: 4.8rem;
  color: inherit;
  font-weight: 800;
  letter-spacing: 0;
}

.language-switcher-flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  font-size: 1rem;
  line-height: 1;
}

.language-switcher-code {
  font-size: 0.82rem;
  line-height: 1;
}

.language-switcher-menu {
  min-width: 10rem;
}
</style>
